<template>
 <div class="divider">
<label class="contentLabel" for="name">{{ $t('Add.General.Name') }}</label>
<input
    type="text"
    id="name"
    v-model="sharedData.data.props.name"
    placeholder="Name eingeben"
    :class="{ errorInput: !isUniqueName }"
/>
<p class="error-message" v-if="!isUniqueName">Name must be unique</p>
    </div>  
</template>

<script>
import { isNameUnique } from '@/utils/isNameUnique';
export default {
    props: ['sharedData'],
    data() {
        return {
            isUniqueName: true,
        };
    },
mounted(){
  this.isUniqueName = isNameUnique(this.sharedData.data.props.name, this.sharedData.id); // Name check  
  ;},
  watch: {
    'sharedData.data.props.name': function(newName) {
      this.isUniqueName = isNameUnique(newName, this.sharedData.id); // Name check
    }
  }
}
</script>

<style>
@import '../../../styles/addComponents.css';
</style>